// Validate the password string about the required json format in Otto documentation
// https://github.com/sonian/otto/blob/master/docs/ods-3070-password-complexity.org#option-1-represent-policies-as-json-documents

import defaultConfig from './password_validator_defaults.json';

const validationStatuses = {
  DIGITS: 'validation_issues.digits',
  UPPERCASE: 'validation_issues.uppercase',
  LOWERCASE: 'validation_issues.lowercase',
  LENGTH: 'validation_issues.length',
  SPECIAL_CHARS: 'validation_issues.special_chars',
  INVALID_CHARS: 'validation_issues.invalid_chars',
};

export default function PassWordValidator(
  validator = defaultConfig,
  validationConstants = validationStatuses,
) {
  const {
    SPECIAL_CHARS = {},
    LENGTH = {},
    DIGITS = {},
    LOWERCASE = {},
    UPPERCASE = {},
  } = validator;

  return {
    validatePassword: (password) => {
      const validationPasses = [];
      const validationIssues = [];

      function storeStatus(status, type) {
        if (status) {
          validationPasses.push(type);
        } else {
          validationIssues.push(type);
        }
      }

      function countChecker(regexp, min = 0, type) {
        const matchStatus = password.match(new RegExp(regexp, 'g')) || [];

        storeStatus(matchStatus.length >= min, type);
      }

      const specialChars = (SPECIAL_CHARS.allowed_vals || []).join('');
      const allowedChars = `a-zA-Z0-9${specialChars}`;

      // Test invalid character status
      storeStatus(
        password.match(new RegExp(`^[${allowedChars}]*$`)),
        validationConstants.INVALID_CHARS,
      );

      // Test length status
      if (LENGTH.required) {
        const lengthMin = LENGTH.min ? LENGTH.min : '';
        const lengthMax = LENGTH.max ? LENGTH.max : '';
        const lengthStatus = password.match(new RegExp(`^.{${lengthMin},${lengthMax}}$`));

        storeStatus(lengthStatus, validationConstants.LENGTH);
      }

      // Test special characters status
      if (SPECIAL_CHARS.required) {
        countChecker(`[${specialChars}]`, SPECIAL_CHARS.min, validationConstants.SPECIAL_CHARS);
      }

      // Test digits status
      if (DIGITS.required) {
        countChecker('[0-9]', DIGITS.min, validationConstants.DIGITS);
      }

      // Test lowercase status
      if (LOWERCASE.required) {
        countChecker('[a-z]', LOWERCASE.min, validationConstants.LOWERCASE);
      }

      // Test uppercase status
      if (UPPERCASE.required) {
        countChecker('[A-Z]', UPPERCASE.min, validationConstants.UPPERCASE);
      }

      return {
        validationPasses,
        validationIssues,
        isValidPassword: !!validationPasses.length && !validationIssues.length,
      };
    },
  };
}
